var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("page-header", {
        attrs: { title: "导入单科考试", paths: ["考试列表", "导入成绩"] },
      }),
      _c(
        "div",
        { staticClass: "main importSingleExam" },
        [
          _vm.step == 1
            ? _c("div", { staticClass: "steps1" }, [
                _c("div", { staticClass: "step-item step-1" }, [
                  _vm._v("第1步：创建考试信息"),
                ]),
                _c("div", { staticClass: "step-item step-2" }, [
                  _vm._v("第2步：上传考试数据"),
                ]),
              ])
            : _vm._e(),
          _vm.step == 2
            ? _c("div", { staticClass: "steps2" }, [
                _c("div", { staticClass: "step-item step-1" }, [
                  _vm._v("第1步：创建考试信息"),
                ]),
                _c("div", { staticClass: "step-item step-2" }, [
                  _vm._v("第2步：上传考试数据"),
                ]),
              ])
            : _vm._e(),
          _vm.step == 1
            ? _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.mainLoading,
                      expression: "mainLoading",
                    },
                  ],
                  ref: "ruleForm",
                  staticClass: "form-wrapper",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "130px",
                  },
                },
                [
                  _c("div", { staticClass: "form-left" }, [
                    _c(
                      "div",
                      { staticClass: "form-base" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "考试名称：", prop: "examName" } },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "small",
                                placeholder: "请输入考试名称",
                              },
                              model: {
                                value: _vm.form.examName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "examName", $$v)
                                },
                                expression: "form.examName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              size: "small",
                              label: "考试类型：",
                              prop: "type",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择考试类型" },
                                model: {
                                  value: _vm.form.type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "type", $$v)
                                  },
                                  expression: "form.type",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "学前测试", value: 1 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "周练", value: 2 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "单元练习", value: 3 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "月练", value: 4 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "期中考试", value: 5 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "期末考试", value: 6 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "模拟考试", value: 7 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "其他", value: 8 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              size: "small",
                              label: "年级：",
                              prop: "grade",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择年级" },
                                on: {
                                  change: function ($event) {
                                    return _vm._handleGradeChange()
                                  },
                                },
                                model: {
                                  value: _vm.form.grade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "grade", $$v)
                                  },
                                  expression: "form.grade",
                                },
                              },
                              _vm._l(_vm.gradeList, function (item) {
                                return _c("el-option", {
                                  key: item.gradeNum,
                                  attrs: {
                                    label: item.gradeName,
                                    value: item.gradeNum,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              size: "small",
                              label: "学科：",
                              prop: "subjectCode",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择学科",
                                  loading: _vm.subjectLoading,
                                },
                                model: {
                                  value: _vm.form.subjectCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "subjectCode", $$v)
                                  },
                                  expression: "form.subjectCode",
                                },
                              },
                              _vm._l(_vm.subjectList, function (item) {
                                return _c("el-option", {
                                  key: item.dicCode,
                                  attrs: {
                                    label: item.dicName,
                                    value: item.dicCode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "form-right" }, [
                    _c(
                      "div",
                      { staticClass: "form-high" },
                      [
                        _c("transition", { attrs: { name: "fade" } }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "check-box" },
                              [
                                _c("div", { staticClass: "check-title" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("images/see.png"),
                                      width: "21",
                                    },
                                  }),
                                  _c("span", [_vm._v("数据显示设置")]),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "老师查看报表：" } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.form.showReport,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "showReport",
                                              $$v
                                            )
                                          },
                                          expression: "form.showReport",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("允许")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [_vm._v("不允许")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "家长推送微信：" } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: { change: _vm.confirmWechat },
                                        model: {
                                          value: _vm.form.isOpen,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "isOpen", $$v)
                                          },
                                          expression: "form.isOpen",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("允许")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [_vm._v("不允许")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("transition", { attrs: { name: "fade" } }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.form.isOpen,
                                          expression: "form.isOpen",
                                        },
                                      ],
                                      staticClass: "wechat-radio",
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "学生答题卷：" } },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: _vm.form.showPaper,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "showPaper",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.showPaper",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [_vm._v("显示")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [_vm._v("不显示")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label:
                                              "年级平均分、校级和班级排名：",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: _vm.form.showGavg,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "showGavg",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.showGavg",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [_vm._v("显示")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [_vm._v("不显示")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "击败年级比例/进退步：",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: _vm.form.showBeat,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "showBeat",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.showBeat",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [_vm._v("显示")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [_vm._v("不显示")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "成绩所在分数段：" },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: _vm.form.showCavg,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "showCavg",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.showCavg",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [_vm._v("显示")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [_vm._v("不显示")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: { "text-align": "center", padding: "60px 0" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "temp",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          href: _vm.getOssUrl(
                            "oss-cn-hangzhou.aliyuncs.com/template/%E5%AF%BC%E5%85%A5%E8%80%83%E8%AF%95%E6%88%90%E7%BB%A9%E6%A8%A1%E6%9D%BF.xls"
                          ),
                          download: "考试数据模板",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { "vertical-align": "top" },
                          attrs: {
                            src: require("images/exam/下载.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" 下载考试数据模板 "),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "margin-bottom": "100px",
                    },
                  },
                  [
                    _vm.progressData > 0
                      ? _c(
                          "div",
                          { staticClass: "input-progress" },
                          [
                            _c("el-progress", {
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 20,
                                percentage: _vm.progressData,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-upload",
                      {
                        ref: "importUpload",
                        staticStyle: { display: "inline" },
                        attrs: {
                          headers: _vm.headers,
                          data: {
                            schoolId: _vm.schoolId,
                            examId: _vm.examId,
                            gradeCode: _vm.form.grade,
                          },
                          action: _vm.getUploadUrl(),
                          "on-progress": _vm.handleProgress,
                          "on-success": _vm.handleUploadSuccess,
                          "on-change": _vm.handleUploadChange,
                          "on-remove": _vm.handRemove,
                          accept: ".xls, .xlsx",
                          "on-error": _vm.handleError,
                          multiple: false,
                        },
                      },
                      [
                        !_vm.uploadLoading
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "primary",
                                  round: "",
                                },
                              },
                              [_vm._v("上传考试数据")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.ifImportError
                      ? _c(
                          "el-button",
                          {
                            staticClass: "download-error-btn",
                            attrs: { type: "text", size: "small" },
                            on: { click: _vm.downloadInportError },
                          },
                          [_vm._v("下载错误信息")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
          _c(
            "div",
            { staticClass: "submit" },
            [
              _vm.step == 1
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        loading: _vm.loading,
                      },
                      on: { click: _vm._createExam },
                    },
                    [_vm._v("下一步")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          attrs: { title: "导入数据异常", visible: _vm.dialogErrorVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogErrorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            _vm._l(_vm.errList, function (e, i) {
              return _c("p", { staticStyle: { "line-height": "25px" } }, [
                _vm._v(_vm._s(i + 1) + "、" + _vm._s(e)),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }